import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=d9b49c0e"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=d9b49c0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports